import { configure, defineRule } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import fr from './validation.json'
import { required, email } from '@vee-validate/rules'

import { isValidIban, isValidBic } from '@ezio/utils'

import { parsePhoneNumber } from 'awesome-phonenumber'


export const initValidations = () => {

    defineRule('required', required)
    defineRule('email', email)




    defineRule('phone', (value: any) => {
        const phone = parsePhoneNumber( value, { regionCode: 'FR' } )
        return phone.valid
    })
    defineRule('iban', (value: string) => {
        return isValidIban(value)
    })
    defineRule('bic', (value: string) => {
        return isValidBic(value)
    })

    defineRule('emailNotRequired', (value: any) => {
        if (!required(value)) {
            return true
        }
        return email(value)
    })

    configure({
        generateMessage: localize({
            fr
        }),
    })
    setLocale('fr')
}
